<template lang="html">
<div class="background"
  :style="
  'background-image: linear-gradient(rgba(51, 51, 51, 0.75), rgb(51, 51, 51)), url(' + image + ')'"
  v-if="image"
>
  &nbsp;
</div>
</template>

<script>
export default {
  name: 'Background',
  props: ['image'],
};
</script>

<style lang="sass" scoped>
.background
  position: fixed
  top: 0
  left: 0
  width: 100%
  width: 100vw
  height: 100%
  height: 100vh
  z-index: -1

  background-color: #333
  background-size: cover
  background-position: center
</style>
